import React, { Fragment, useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import {
    Alert,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Button,
    Popover,
    PopoverBody,
    PopoverHeader,
} from "reactstrap";
import { toast } from "react-toastify";
import moment from "moment";
import restockReportReducer from "../store";
import withReducer from "../../../store/withReducer";
import Breadcrumb from "../../../layout/breadcrumb";
import { mapRestockReportResponseToTable, mapSearchAutoSuggestion } from "../../../utils/mapper";

import {
    setRestockReportFilter,
    setReturnRestockData,
    exportReturnRestockReport,
} from "../store/restockReportSlice";

import { getOrderSettings, setSettings } from "../store/orderSlice";
import { sellerAutoSuggestionApi } from "../../../services/manage-product/productService";
import { getBrands } from "../../manage-product/store/inventorySlice";
import { getTrackings, downloadTrackingLabel, downloadTrackingLabelQRCode } from "../store/trackingSlice";

import CommonDataTable from "../../../share-components/table/commonDataTable";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import "./style.scss";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import { formatterDecimal } from "../../../utils/common";

const { afterToday } = DateRangePicker;


const ActionColumnCell = ({row}) => {
    const dispatch = useDispatch();
    const [labelButtonDisabled, setLabelButtonDisabled] = useState(false);
    const [labelQRCodeButtonDisabled, setLabelQRCodeButtonDisabled] = useState(false);

    const downloadLabelClick = (tracking_id) => {
        setLabelButtonDisabled(true);

        const data = {
            id: tracking_id,
        }

        dispatch(downloadTrackingLabel(data)).then(res => {
            const link = document.createElement('a');
            link.href = res.payload;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLabelButtonDisabled(false);
        });
    }

    const downloadLabelQRCodeClick = (tracking_id) => {
        setLabelQRCodeButtonDisabled(true);

        const data = {
            id: tracking_id,
        }

        dispatch(downloadTrackingLabelQRCode(data)).then(res => {
            const link = document.createElement('a');
            link.href = res.payload;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLabelQRCodeButtonDisabled(false);
        });
    }

    return (<>
        <Button color="success" outline={true} size="xs" type="button" className="pt-1 ml-1" onClick={() => {
            downloadLabelClick(row.id)
        }} disabled={labelButtonDisabled || !row.actions.is_available_label} title={row.actions.is_available_label ? '' : 'Label not available'}>
            {labelButtonDisabled ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-download" />} Label
        </Button>
        <Button color="dark" outline={true} size="xs" type="button" className="pt-1 ml-1" onClick={() => {
            downloadLabelQRCodeClick(row.id)
        }} disabled={labelQRCodeButtonDisabled || !row.actions.is_available_label_qrcode} title={row.actions.is_available_label_qrcode ? '' : 'QR Code not available'}>
            {labelQRCodeButtonDisabled ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-download" />} QR Code
        </Button>
    </>);
}

const Trackings = () => {
    const dispatch = useDispatch();
    let history = useHistory();

    const userState = useSelector(({ authReducer }) => authReducer.data);
    const orderState = useSelector(({ order }) => order.order);

    const TodayDate = new Date();
    const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
    const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
    const [startDate, endDate] = dateRange;

    const [loading, setLoading] = useState(true);

    const [timer, setTimer] = useState(null);
    const [fillterSeller, setFillterSeller] = useState(null);
    const [fillterBrand, setFillterBrand] = useState(null);
    const [fillterPartner, setFillterPartner] = useState(null);
    const [fillterDeliveryPartner, setFillterDeliveryPartner] = useState(null);
    const [fillterTrackingStatus, setFillterTrackingStatus] = useState(null);
    const [fillterTrackingType, setFillterTrackingType] = useState(null);
    const [lastFillters, setLastFillters] = useState(null);
    const [filters, setFilters] = useState({
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
        currentPage: 1,
        pageSize: 10,
        seller_id: null,
        brand_id: null,
        partner_id: null,
        partner_id: null,
    });

    const trackingStatuses = [
        // { 'id': 0, 'name': 'All' },
        { 'id': 1, 'name': 'Pending' },
        { 'id': 2, 'name': 'In Transit' },
        { 'id': 3, 'name': 'Delivered' },
    ];

    const trackingTypes = [
        { 'id': 1, 'name': 'Order Tracking' },
        { 'id': 2, 'name': 'Return Tracking' },
        { 'id': 3, 'name': 'Decline Tracking' },
    ];

    const [brands, setBrands] = useState(null);

    const trackingState = useSelector(({ order }) => order.tracking);
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const authData = useSelector(({ authReducer }) => authReducer);

    useEffect(() => {
        dispatch(getOrderSettings()).then(res => {
            dispatch(setSettings(res.payload))
        });
    }, [dispatch]);


    useEffect(() => {
        const data = {
            value: '',
            seller_id: filters.seller ? filters.seller.value : '',
        }
        dispatch(getBrands(data)).then(res => {
            setBrands(res.payload);
        });
    }, [dispatch, filters.seller]);


    const getData = () => {
        if (JSON.stringify(filters) == JSON.stringify(lastFillters)) return;

        setLastFillters({ ...filters });
        setLoading(true);

        dispatch(
            getTrackings(filters)
        );
    };

    useEffect(() => {
        getData();
    }, [filters]);

    
    useEffect(() => {
        setFilters(prev => ({
            ...prev,
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD"),
            seller_id: fillterSeller ? fillterSeller.value : null,
            brand_id: fillterBrand ? fillterBrand.id : null,
            partner_id: fillterPartner ? fillterPartner.id : null,
            delivery_partner_id: fillterDeliveryPartner ? fillterDeliveryPartner.id : null,
            tracking_status: fillterTrackingStatus ? fillterTrackingStatus.id : null,
            tracking_type: fillterTrackingType ? fillterTrackingType.id : null,
        }));
    }, [startDate, endDate, fillterSeller, fillterBrand, fillterPartner, fillterDeliveryPartner, fillterTrackingStatus, fillterTrackingType]);


    const dataMenu = [
        {
            type: 0,
            text: "Trackings",
        },
    ];

    const PopoverBasicItem = (props) => {
        const { id, btntext, Popoverbody } = props;
        const [popover, setPopover] = useState(false)
        const Toggle = () => setPopover(!popover);
        return (
            <>
                <p style={{ cursor: "pointer" }} className="example-popover" id={"Popover-" + id}>{btntext} <i className="fa fa-info-circle"></i></p>
                <Popover
                    placement="top"
                    isOpen={popover}
                    target={"Popover-" + id}
                    toggle={Toggle}
                    trigger="hover"
                >
                    <PopoverBody>
                        {Popoverbody}
                    </PopoverBody>
                </Popover>
            </>
        );
    };

    const tableColumns = [
        {
            name: "Order ID",
            selector: (row) => row.orderName,
            sortable: false,
            center: false
        },
        {
            name: "Seller",
            // selector: (row) => row.seller,
            selector: (row) => {
                const sellerListArray = row.sellerLists ? row.sellerLists : [];

                if (sellerListArray.length > 1) {
                    const sellerNames = sellerListArray.join(', ');

                    return (
                        <PopoverBasicItem id={row.id} btntext={row.seller} Popoverbody={sellerNames} />
                    );
                } else {
                    return row.seller;
                }
            },
            sortable: false,
            center: false,
        },
        {
            name: "Delivery Partner",
            selector: (row) => row.deliveryPartner,
            sortable: false,
            center: false,
        },
        {
            name: "Tracking Number",
            selector: (row) => row.trackingNumber,
            sortable: false,
            center: false,
        },
        {
            name: "Tracking URL",
            selector: (row) => row.trackingUrl,
            sortable: false,
            left: true,
        },
        {
            name: "Tracking Status",
            selector: (row) => row.trackingStatus,
            sortable: false,
            center: true,
        },
        {
            name: "Tracking Date",
            selector: (row) => row.trackingDate,
            sortable: false,
            center: true,
        },
        {
            name: "Type",
            selector: (row) => row.type,
            sortable: false,
            center: true,
        },
        {
            name: "Actions",
            selector: (row) => row.type,
            cell: (row => <ActionColumnCell row={row} />),
            sortable: false,
            right: true,
        },
    ];

    const pageChange = (e) => {
        setFilters({
            ...filters,
            currentPage: e,
        });
    };

    const pagination = (e) => {
        setFilters({
            ...filters,
            currentPage: 1,
            pageSize: e,
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: 50,
            border: "none",
        }),
    };

    const handleRowSelected = (state) => {
        const items = state.selectedRows.map((row) => {
            // let dataIndex = returnData.findIndex((x) => x.id == row.id);
            // if (dataIndex !== -1) {
            //     let item = { ...returnData[dataIndex] };
            //     row.completeRestock = item.completeRestock;
            // }

            return row;
        });

        setSelectedRows(items);
    };

    // const exportRestockReport = () => {
    //     setBtnDisable(true);

    //     dispatch(exportReturnRestockReport({ ...data })).then(res => {
    //         const downloadLink = document.createElement('a');
    //         downloadLink.href = res.payload;
    //         document.body.appendChild(downloadLink);
    //         downloadLink.click();

    //         // Clean up by removing the download link from the document body
    //         document.body.removeChild(downloadLink);
    //         setBtnDisable(false);
    //     });
    // }


    // data provides access to your row data
    const ExpandedComponent = ({ data }) => {
        
        const childTableColumns = [
            {
                name: "SKU",
                selector: (row) => row.sku,
                sortable: false,
                left: true,
            },
            {
                name: "Quantity",
                selector: (row) => row.quantity,
                sortable: false,
                center: true,
            },
            {
                name: "Total",
                selector: row => formatterDecimal.format(row.total),
                sortable: false,
                right: true,
            },
        ];

        const childData = data.items;

        return (
            <div className="px-5 pt-3 pb-5 border-bottom">
                <CommonDataTable
                    headerColumns={childTableColumns}
                    data={childData}
                    noAction
                    pagination={false}
                />
            </div>
        );
    };

    const sellerPromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue
            }
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(sellerAutoSuggestionApi(data)))
            });
        });

    return (
        <Fragment>
            <Breadcrumb title="Trackings" data={dataMenu} />
            <Container fluid={true}>
                <div className="product-grid">
                    <div className="feature-products">
                        <Row>
                            <Col sm="" className="mb-3">
                                <Form>
                                    <FormGroup className="m-0">
                                        <DatePicker
                                            dateRange={dateRange}
                                            dateRangeChange={(update) => {
                                                setDateRange(update)
                                            }}
                                            disabledDate={afterToday()}
                                            defaultValue={[TodayDate, sevenDays]}
                                            paddingLeft={0}
                                        />
                                    </FormGroup>
                                </Form>
                            </Col>

                            {/* <Col sm="" className="mb-3">
                                <div className='float-sm-right'>
                                    <Button
                                        color="primary"
                                        className="btn btn-primary btn-square"
                                        disabled={btnDisable}
                                        onClick={() => { exportRestockReport() }}>
                                        {btnDisable ? <i className="fa fa-spinner fa-spin spinner mr-1" /> : ''}
                                        Export as Excel
                                    </Button>
                                </div>
                            </Col> */}
                        </Row>

                        <Row>
                            {userState.user.role.name !== "Seller" && <Col md="" className="mb-3">
                                <AsyncSelect
                                    className="select2-filter"
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    value={fillterSeller}
                                    defaultOptions
                                    placeholder="Filter by Seller"
                                    loadOptions={sellerPromiseOption}
                                    styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 100 }) }}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    onChange={(e) => {
                                        setFillterSeller(e);
                                    }}
                                />
                            </Col>}

                            <Col md="" className="mb-3">
                                <Select
                                    placeholder="Filter by Seller Brand"
                                    className="select2-filter"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    isClearable
                                    cacheOptions
                                    styles={customStyles}
                                    options={brands}
                                    defaultValue={fillterBrand}
                                    onChange={(e) => {
                                        setFillterBrand(e);
                                    }}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </Col>

                            {((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) && (
                                <Col sm="" className="mb-3">
                                    <Select
                                        placeholder="Filter by Partner"
                                        className="select2-filter"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        isClearable
                                        cacheOptions
                                        styles={customStyles}
                                        defaultValue={fillterPartner}
                                        options={orderState.settings.partner}
                                        onChange={(e) => {
                                            setFillterPartner(e);
                                        }}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                    />
                                </Col>
                            )}

                            <Col sm="" className="mb-3">
                                <Select
                                    placeholder="Filter by Delivery Partners"
                                    className="select2-filter"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    isClearable
                                    cacheOptions
                                    styles={customStyles}
                                    defaultValue={fillterDeliveryPartner}
                                    options={orderState.settings.deliveryPartners}
                                    onChange={(e) => {
                                        setFillterDeliveryPartner(e);
                                    }}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </Col>

                            <Col sm="" className="mb-3">
                                <Select
                                    className="select2-filter"
                                    styles={customStyles}
                                    placeholder="Filter by Type"
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={fillterTrackingType}
                                    onChange={(e) => {
                                        setFillterTrackingType(e);
                                    }}
                                    isClearable={true}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    options={trackingTypes}
                                />
                            </Col>

                            {((userState.user.role.name !== "Seller") || (userState.user.is_primary_seller)) &&
                                <Col sm="" className="mb-3">
                                    <Select
                                        className="select2-filter"
                                        styles={customStyles}
                                        placeholder="Filter by Tracking Status"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        value={fillterTrackingStatus}
                                        onChange={(e) => {
                                            setFillterTrackingStatus(e);
                                        }}
                                        isClearable={true}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        options={trackingStatuses}
                                    />
                                </Col>
                            }
                        </Row>

                        <Row>
                            <Col md="">
                                <Form onSubmit={(e) => {
                                    e.preventDefault();
                                }}>
                                    <FormGroup className="m-0">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            defaultValue={filters.sku}
                                            onKeyDown={(e) => {
                                                clearTimeout(timer);
                                                const newTimer = setTimeout(() => {
                                                    setFilters({
                                                        ...filters,
                                                        sku: e.target.value,
                                                        currentPage: 1,
                                                    });
                                                }, 500);
                                                setTimer(newTimer);
                                            }}
                                            placeholder="Search By SKU"
                                        />
                                        <i className="fa fa-search"></i>
                                    </FormGroup>
                                </Form>
                            </Col>
                            <Col md="">
                                <Form onSubmit={(e) => {
                                    e.preventDefault();
                                }}>
                                    <FormGroup className="m-0">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            defaultValue={filters.trackingNumber}
                                            onKeyDown={(e) => {
                                                clearTimeout(timer);
                                                const newTimer = setTimeout(() => {
                                                    setFilters({
                                                        ...filters,
                                                        trackingNumber: e.target.value,
                                                        currentPage: 1,
                                                    });
                                                }, 500);
                                                setTimer(newTimer);
                                            }}
                                            placeholder="Search By Tracking Number"
                                        />
                                        <i className="fa fa-search"></i>
                                    </FormGroup>
                                </Form>
                            </Col>
                            <Col md="">
                                <Form onSubmit={(e) => {
                                    e.preventDefault();
                                }}>
                                    <FormGroup className="m-0">
                                        <Input
                                            type="text"
                                            className="form-control"
                                            defaultValue={filters.orderNumber}
                                            onKeyDown={(e) => {
                                                clearTimeout(timer);
                                                const newTimer = setTimeout(() => {
                                                    setFilters({
                                                        ...filters,
                                                        orderNumber: e.target.value,
                                                        currentPage: 1,
                                                    });
                                                }, 500);
                                                setTimer(newTimer);
                                            }}
                                            placeholder="Search Order ID / MP Order Number"
                                        />
                                        <i className="fa fa-search"></i>
                                    </FormGroup>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </div>

                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <CommonDataTable
                                    headerColumns={tableColumns}
                                    data={trackingState.trackingsLists}
                                    noAction
                                    selectableRows={false}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleCleared}
                                    paginationServer
                                    paginationTotalRows={
                                        trackingState.tableRow
                                    }
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    onChangeRowsPerPage={pagination}
                                    onChangePage={pageChange}
                                    expandableRows
                                    expandableRowsComponent={ExpandedComponent}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default withReducer([{ order: restockReportReducer }])(Trackings);
